import { __assign, __extends } from "tslib";
import React from 'react';
import mergeWith from 'lodash/mergeWith';
import classnames from 'classnames';
import { RichContentViewer } from 'wix-rich-content-viewer';
import { Url } from '@wix/da-url';
import isEmpty from 'lodash/isEmpty';
import { IMAGE_TYPE, IMAGE_TYPE_LEGACY, } from '../../plugins/plugin-image/types';
import { typeMapper as emoteTypeMapper } from '../../plugins/emote/typeMapper';
import { typeMapper as mentionTypeMapper } from '../../plugins/mention/typeMapper';
import { typeMapper as galleryTypeMapper } from '../../plugins/plugin-gallery/typeMapper';
import { typeMapper as imageTypeMapper } from '../../plugins/plugin-image/typeMapper';
import { typeMapper as videoTypeMapper } from '../../plugins/plugin-video/typeMapper';
import { linkTypeMapper, LINK_TYPE } from 'wix-rich-content-plugin-link/viewer';
import { giphyTypeMapper } from 'wix-rich-content-plugin-giphy/viewer';
import { typeMapper as linkPreviewTypeMapper } from '../../plugins/plugin-link-preview/typeMapper';
import { dividerTypeMapper } from 'wix-rich-content-plugin-divider/viewer';
import { HashtagDecorator } from 'wix-rich-content-plugin-hashtag/viewer';
import { textColorInlineStyleMapper, TEXT_COLOR_TYPE, } from 'wix-rich-content-plugin-text-color/viewer';
import withFeatureFlags from '@wix/da-react-context/pkg/flags/withFeatureFlags';
import baseTheme from '../../theme';
import { ThemeContext, } from '@wix/da-react-context/pkg/ThemeContext';
import LazyContext from '../../../LazyLoadingImage/LazyContext';
import ddt from '@wix/da-ddt';
import daContentNormalizer from './daContentNormalizer';
import { viewerCustomForegroundStyleFn, styleSelectionPredicate, } from '../../plugins/text-color-style-fn';
import { scrollIntoViewWithHeader } from '../../../utils/scrollIntoViewWithHeader';
var anchorTarget = '_top';
var relValue = 'noreferrer';
var DaViewer = /** @class */ (function (_super) {
    __extends(DaViewer, _super);
    function DaViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.getInlineStyleMappers = function (raw) {
            var _a;
            return [
                textColorInlineStyleMapper((_a = {},
                    _a[TEXT_COLOR_TYPE] = {
                        styleSelectionPredicate: styleSelectionPredicate,
                        customStyleFn: viewerCustomForegroundStyleFn,
                    },
                    _a), raw),
            ];
        };
        _this.customAnchorScroll = function (ev, anchor) {
            var anchorEl = document.getElementById("viewer-" + anchor);
            anchorEl &&
                scrollIntoViewWithHeader(anchorEl, _this.props.isMobile, 0, undefined, true, true);
        };
        _this.initViewerProps(props);
        return _this;
    }
    DaViewer.prototype.shouldComponentUpdate = function (nextProps) {
        if (nextProps.globalTheme !== this.props.globalTheme) {
            return true;
        }
        return false;
    };
    DaViewer.prototype.initViewerProps = function (props) {
        var imageComponent = props.imageComponent, galleryComponent = props.galleryComponent, videoComponent = props.videoComponent;
        this.theme = mergeWith(__assign({}, baseTheme), props.theme || {}, function (defaultStyleClassName, themeClassName) {
            return classnames(defaultStyleClassName, themeClassName);
        });
        this.typeMappers = [
            imageTypeMapper(imageComponent),
            mentionTypeMapper,
            emoteTypeMapper,
            linkTypeMapper,
            linkPreviewTypeMapper,
            galleryTypeMapper(galleryComponent),
            videoTypeMapper(videoComponent),
            giphyTypeMapper,
            dividerTypeMapper,
        ];
        this.decorators = [
            new HashtagDecorator({
                theme: this.theme,
                createHref: function (tag) { return Url.tagsPageLink(tag); },
            }),
        ];
    };
    DaViewer.prototype.getThemeClassName = function () {
        var isDarkTheme = this.props.isDarkTheme;
        return "da-editor-theme-" + (isDarkTheme ? 'dark' : 'bright');
    };
    DaViewer.prototype.getWrapperProps = function () {
        var _a = this.props, fixedParagraph = _a.fixedParagraph, showMediaAlwaysSmall = _a.showMediaAlwaysSmall;
        var wrapperProps = {};
        if (fixedParagraph) {
            wrapperProps['data-daeditor-fixed-paragraph'] = true;
        }
        if (showMediaAlwaysSmall) {
            wrapperProps['data-daeditor-small-media'] = true;
        }
        wrapperProps.className = this.getThemeClassName();
        return wrapperProps;
    };
    DaViewer.prototype.render = function () {
        var _a;
        var _b = this.props, isMobile = _b.isMobile, content = _b.content, fixedParagraph = _b.fixedParagraph, showMediaAlwaysSmall = _b.showMediaAlwaysSmall;
        if (isEmpty(content)) {
            return null;
        }
        var settings = {
            fixedParagraph: fixedParagraph,
            showMediaAlwaysSmall: showMediaAlwaysSmall,
        };
        // apply some global settings to relevant plugins
        var config = (_a = {},
            _a[IMAGE_TYPE] = settings,
            _a[IMAGE_TYPE_LEGACY] = settings,
            _a[LINK_TYPE] = {},
            _a);
        var initState = daContentNormalizer(content);
        return content ? (React.createElement("div", __assign({}, this.getWrapperProps()),
            React.createElement(LazyContext.Provider, { value: true },
                React.createElement(RichContentViewer, { typeMappers: this.typeMappers, decorators: this.decorators, initialState: initState, inlineStyleMappers: this.getInlineStyleMappers(initState), theme: this.theme, isMobile: isMobile, anchorTarget: anchorTarget, relValue: relValue, config: config, customAnchorScroll: this.customAnchorScroll, onError: function (e) {
                        ddt.error('editor', 'Failed to render editor view', e);
                    } })))) : null;
    };
    return DaViewer;
}(React.Component));
export { DaViewer };
var globalThemeHoc = function (Component) {
    return function (props) {
        return (React.createElement(ThemeContext.Consumer, null, function (theme) { return React.createElement(Component, __assign({ globalTheme: theme }, props)); }));
    };
};
export default globalThemeHoc(withFeatureFlags(DaViewer));
//# sourceMappingURL=Viewer.js.map